import { methods } from "../../utils/axios";

export default class GuestPaymentsAPI {
  static list() {
    return methods.get('/payments/guest/unassigned');
  }

  static assign(paymentId, clientId) {
    return methods.post(`/payments/${paymentId}/assign`, { clientId });
  }
}
